/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser'
import { getPolicyEndpoints } from './src/utils'

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

const { policyEndpoint, clientId } = getPolicyEndpoints()

export const b2cPolicies = {
  authorities: {
    signInCustom: {
      authority: `https://${policyEndpoint}.b2clogin.com/${policyEndpoint}.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN_CUSTOM_FE`
    },
    passwordChange: {
      authority: `https://${policyEndpoint}.b2clogin.com/${policyEndpoint}.onmicrosoft.com/B2C_1A_PASSWORDCHANGE`
    },
    emailChange: {
      authority: `https://${policyEndpoint}.b2clogin.com/${policyEndpoint}.onmicrosoft.com/B2C_1A_CHANGE_EMAIL`
    }
  },
  authorityDomain: `${policyEndpoint}.b2clogin.com`
}

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: b2cPolicies.authorities.signInCustom.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri:
      typeof window !== 'undefined' && window.location.origin + '/auth',
    postLogoutRedirectUri:
      typeof window !== 'undefined' && window.location.origin,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)

          default:
        }
      }
    }
  }
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['openid', 'offline_access']
}

// /**
//  * An optional silentRequest object can be used to achieve silent SSO
//  * between applications by providing a "login_hint" property.
//  */
// export const silentRequest = {
//     scopes: ["openid", "profile"],
//     loginHint: "example@domain.net"
// };
